import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { 
  BarChart3,
  TrendingUp,
  Package,
  DollarSign,
  Calendar,
  Clock,
  Layers,
  Tag,
  GitCompare,
  AlertCircle,
  FileSpreadsheet,
  Settings
} from "lucide-react";

const REPORTS = [
  {
    id: "gunluk-satis",
    title: "Günlük Satış Raporu",
    description: "Günlük satış özeti ve mağaza performansı",
    icon: Calendar,
    color: "bg-blue-500",
    path: "/nebim/raporlar/gunluk-satis"
  },
  {
    id: "urun-satis-analizi",
    title: "Ürün Satış Analizi",
    description: "Ürün bazlı satış detayları",
    icon: TrendingUp,
    color: "bg-emerald-500",
    path: "/nebim/raporlar/urun-satis-analizi"
  },
  {
    id: "en-cok-satan-haftalik",
    title: "En Çok Satanlar (Haftalık)",
    description: "Haftalık en çok satan ürünler",
    icon: BarChart3,
    color: "bg-orange-500",
    path: "/nebim/raporlar/en-cok-satan-haftalik"
  },
  {
    id: "en-cok-satan-aylik",
    title: "En Çok Satanlar (Aylık)",
    description: "Aylık en çok satan ürünler",
    icon: BarChart3,
    color: "bg-amber-500",
    path: "/nebim/raporlar/en-cok-satan-aylik"
  },
  {
    id: "envanter",
    title: "Ürün Envanter Raporu",
    description: "Depo bazlı stok durumu",
    icon: Package,
    color: "bg-purple-500",
    path: "/nebim/raporlar/envanter"
  },
  {
    id: "karlilik",
    title: "Ürün Karlılık Raporu",
    description: "Ürün bazlı kâr analizi",
    icon: DollarSign,
    color: "bg-green-500",
    path: "/nebim/raporlar/karlilik"
  },
  {
    id: "gunluk-satis-detayli",
    title: "Günlük Satış Raporu (Detaylı)",
    description: "KDV, iskonto dahil detaylı rapor",
    icon: FileSpreadsheet,
    color: "bg-indigo-500",
    path: "/nebim/raporlar/gunluk-satis-detayli"
  },
  {
    id: "satis-hizi",
    title: "Ürün Satış Hızı Raporu",
    description: "Ürün satış hızı analizi",
    icon: Clock,
    color: "bg-cyan-500",
    path: "/nebim/raporlar/satis-hizi"
  },
  {
    id: "hierarsi-satis",
    title: "Hierarşi Satış Raporu",
    description: "Kategori bazlı satış raporu",
    icon: Layers,
    color: "bg-rose-500",
    path: "/nebim/raporlar/hierarsi-satis"
  },
  {
    id: "ozellik-satis",
    title: "Özellik Satış Raporu",
    description: "Özellik bazlı satış analizi",
    icon: Tag,
    color: "bg-violet-500",
    path: "/nebim/raporlar/ozellik-satis"
  },
  {
    id: "karsilastirma",
    title: "Karşılaştırma Raporu",
    description: "Dönemsel karşılaştırma",
    icon: GitCompare,
    color: "bg-teal-500",
    path: "/nebim/raporlar/karsilastirma"
  },
  {
    id: "satilmayan",
    title: "Satılmayan Ürünler",
    description: "Belirli sürede satılmayan ürünler",
    icon: AlertCircle,
    color: "bg-red-500",
    path: "/nebim/raporlar/satilmayan"
  },
  {
    id: "karlilik-site",
    title: "Ürün Karlılık Raporu (Site Bazlı)",
    description: "Site bazlı kâr analizi",
    icon: DollarSign,
    color: "bg-lime-500",
    path: "/nebim/raporlar/karlilik-site"
  },
  {
    id: "ozel",
    title: "Özel Raporlar",
    description: "Özelleştirilmiş raporlar",
    icon: Settings,
    color: "bg-slate-500",
    path: "/nebim/raporlar/ozel"
  }
];

export default function RaporlarPage() {
  return (
    <div className="space-y-6 fade-in" data-testid="raporlar-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Raporlar</h1>
        <p className="text-slate-500 text-sm">Satış, stok ve performans raporları</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {REPORTS.map((report) => (
          <Link key={report.id} to={report.path}>
            <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer group">
              <CardContent className="p-6">
                <div className={`w-12 h-12 ${report.color} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <report.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-1">{report.title}</h3>
                <p className="text-sm text-slate-500">{report.description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
